// extracted by mini-css-extract-plugin
export var container = "Footer-module--container--9cou0";
export var bottom = "Footer-module--bottom--+hOQW";
export var menu = "Footer-module--menu--kN3c5";
export var socialLinks = "Footer-module--socialLinks--508Lf";
export var accreditations = "Footer-module--accreditations--7+Ydy";
export var cepa = "Footer-module--cepa--wwhvL";
export var copyright = "Footer-module--copyright--4GVUc";
export var credit = "Footer-module--credit--Jz+Ir";